import { create } from "zustand";

import type { ZPeopleState } from "../types/zustand.type";

import { companyDatabaseSlice } from "./slice";

export const usePeopleDatabaseStore = create<ZPeopleState>()((...args) => ({
  ...companyDatabaseSlice(...args),
}));
